import React from 'react';
import { MobileMenu } from './MobileMenu';

export function Navbar({ isMobileMenuOpen, toggleMobileMenu }) {
  return (
    <nav className="bg-white border-b sticky top-0 z-50">
      <div className="px-4 h-14 flex items-center justify-between">
        <h1 className="text-xl font-semibold">Sistema POS</h1>
        <MobileMenu isOpen={isMobileMenuOpen} onToggle={toggleMobileMenu} />
      </div>
    </nav>
  );
}